import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, IntlProvider } from 'react-intl';

import { messages as m } from '../../constants/Fallback';

import './Fallback.scss';

const ERROR_STACK_LENGTH = 300;
const INFO_STACK_lENGTH = 500;

let FallbackComponent = class Fallback extends React.Component {
  render() {
    return (
      <div className='Fallback__prod'>
        <h1 className='Fallback__heading'>Something went wrong.</h1>
        <h1 className='Fallback__subHeading'>
          Try refreshing the page and if the problem continues, please come back and try again
          later.
        </h1>
      </div>
    );
  }
};

if (__RELEASE_STAGE__ !== 'production') {
  FallbackComponent = class Fallback extends React.Component {
    static propTypes = {
      error: PropTypes.object,
      info: PropTypes.object,
    };

    render() {
      const error = this.props.error && this.props.error.toString();
      let errorStack =
        this.props.error && this.props.error.stack && this.props.error.stack.toString();
      let infoStack = this.props.info && this.props.info.componentStack.toString();

      if (errorStack.length > ERROR_STACK_LENGTH) {
        errorStack = errorStack.slice(0, ERROR_STACK_LENGTH) + '...';
      }

      if (infoStack.length > INFO_STACK_lENGTH) {
        infoStack = infoStack.slice(0, INFO_STACK_lENGTH) + '...';
      }

      return (
        <IntlProvider locale='en'>
          <div className='Fallback'>
            <h1 className='Fallback__heading'>
              <FormattedMessage {...m.somethingWentWrong} />
            </h1>
            <div className='Fallback__content'>
              <FormattedMessage {...m.errorDescription} />
              <h3 className='Fallback__error'>{error}</h3>
              <h4 className='Fallback__stack'>{errorStack}</h4>
            </div>
            <div className='Fallback__content'>
              <FormattedMessage {...m.infoStack} />
              <h4 className='Fallback__stack'>{infoStack}</h4>
            </div>
            <h1 className='Fallback__heading'>
              <FormattedMessage {...m.refreshPrompt} />
            </h1>
            <h3 className='Fallback__heading'>
              <FormattedMessage {...m.inspiringQuote} />
            </h3>
          </div>
        </IntlProvider>
      );
    }
  };
}

export default FallbackComponent;
